export const defaultFormState = {
    calculation: {
      amount: 0,
      endDate: '',
      waiverOfRedemption: false,
      isNonCash: false,
      months: null,
      firstPaymentDate: null
    },
  };